<template>
  <BaseModal title="购买次数包" v-model="show" :width="420">
    <a-alert type="warning" show-icon>
      <template slot="message">
        每张图片对应消耗一次，请自行根据情况购买次数
      </template>
    </a-alert>
    <div>&nbsp;</div>
    <a-form-model-item label="购买次数">
      <a-radio-group v-model="count">
        <a-radio-button :value="10000">1万次</a-radio-button>
        <a-radio-button :value="20000">2万次</a-radio-button>
        <a-radio-button :value="30000">3万次</a-radio-button>
        <a-radio-button :value="50000">5万次</a-radio-button>
        <a-radio-button :value="100000">10万次</a-radio-button>
      </a-radio-group>
    </a-form-model-item>
    <a-button type="primary" shape="round" size="large" block @click="toPay">确认购买{{ amount|formatCNF }}</a-button>
    <CommonPay ref="pay" :user="user" :wxpay="wxpay" :prepay="prepay" :probe="probe" @paid="afterPaid" title="购买次数包"/>
  </BaseModal>
</template>

<script>
import api from "../../../../utils/api";
import BaseModal from "../../../../comps/BaseModal";
import DelayLoading from "../../../../comps/DelayLoading";
import CommonPay from "@/comps/CommonPay";

export default {
  name: "BuyDetect",
  props: {user: Object},
  components: {CommonPay, BaseModal},
  mixins: [DelayLoading],
  data() {
    return {
      show: false,
      count: 10000, // 购买次数
    }
  },
  computed: {
    amount() {
      return this.count * 0.01 * 100;
    }
  },
  methods: {
    open() {
      this.show = true;
    },
    toPay() {
      this.$refs.pay.open(this.amount);
    },
    wxpay() {
      let args = {count: this.count};
      return api.v1.user.detect.create(args).then(res => {
        return api.v1.user.detect.toPay(res.id, {channel: 15});
      });
    },
    async probe(id) {
      let res = await api.v1.user.detect.isPaid(id);
      return res["is_paid"];
    },
    prepay() {
      let args = {count: this.count};
      return api.v1.user.detect.create(args).then(res => {
        return api.v1.user.detect.prepay(res.id);
      });
    },
    afterPaid() {
      window.location.reload();
    }
  }
}
</script>

<style scoped lang="less">
.ant-slider {
  margin-top: 10px;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  color: #ffffff;
  background: #1890ff;
}
</style>
